import React from 'react';
import './InfoItemValue.less';

export const InfoItemValue = ({text, isBold}) => {
	return <span className={`info-item-value ${
		isBold ? 'info-item-value--bold' : ''
	}`}>{text}</span>
}
